import React, { useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin"
import MytFooter from "../../Components/MytFooter"
// import { getRestoLogin } from "../../Helpers/Utils/Common"


function AuditTrails() {
  const [inactive, setInactive] = useState(true)
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  })
  // let date = new Date().toLocaleDateString("en-CA")
  // const restoType = getRestoLogin();

  const handleFilter = (e) => {
    const { name, value } = e.target
    var filtercopy = { ...filter }
    filtercopy[name] = value
    setFilter(filtercopy)
  }

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive)
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container ps-5 pt-4 bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col xl={6}>
            <h1 className="page-title-menu"> E-JOURNAL REPORT</h1>
          </Col>
          <Col xl={6}>
          </Col>
        </Row>
        
        <hr />
        <div className="table-content">
          <div className="my-2 px-4 PO-filters d-flex">
            <span className="me-1 align-middle mt-2">FILTER BY</span>
            <span className="me-4 align-middle mt-2">DATE:</span>
            <Form.Control
              size="sm"
              type="date"
              name="date_to"
              className="date-filter me-3"
              onChange={handleFilter}
              value={filter.date_to}
            />
          </div>
        </div>

        <div className="row">
          <Col xs="5"></Col>
          <Col xs="3" className="pt-5">
            <button className="export-btn">
              <a
                style={{ textDecoration: "none", color: "#ffffff" }}
                href={`http://localhost/smash-pos-api/public/ej/${filter.date_to}.txt`}
              >
                Export to Ejournal
              </a>
            </button>
          </Col>
          <Col xs="3"></Col>
        </div>
      </div>
      <MytFooter/>
    </div>
  )
}

export default AuditTrails
